module.exports = __webpack_public_path__ + "static/media/upload-image.16a2c815.svg";